import Vue from 'vue';
import App from './App.vue';
import { BootstrapVue } from 'bootstrap-vue';
import VueI18n from 'vue-i18n';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use( BootstrapVue );
Vue.use( VueI18n );

const messages = {
	en: {
		welcomeMsg: "Should we meet or not?",
		recipients: "<Your TO list>",
		subject: "<A cool Subject>",
		recipientsLabel: 'To',
		subjectLabel: 'Subject',
		emailLabel: 'Message',
		meetingReasonLabel: "Reason for the meeting",
		check: "Check",
		result: "Just send an email!",
		msg: "I hope you get it!",
		aboutLabel: "About",
		aboutText: `MeetOrNot emerges as a tongue-in-cheek critique of the prevalent culture of scheduling unnecessary meetings that could easily be replaced by a straightforward email. In today's fast-paced work environment, excessive meetings not only disrupt productivity but also lead to 'meeting fatigue,' contributing to a decline in team performance and individual motivation.
		<br><br>
		Statistics reveal that professionals spend approximately 31 hours per month in unproductive meetings, with an estimated 47% considering excessive meetings as the number one time-waster at the office. This over-reliance on meetings hampers decision-making processes, stifles creativity, and can often lead to the overlooking of valuable, introspective work periods known for fostering innovation.
		<br><br>
		With MeetOrNot, we aim to inject a bit of humor into the workplace by encouraging professionals to pause and consider whether another meeting is truly necessary or if the same outcome could be achieved through a well-crafted email. Here's to reclaiming your time, boosting productivity, and enhancing the quality of workplace communication!`,
		aboutLink: "About the Author",
		loadingMessages: ['Checking if people are interested...', 'Checking if it is really necessary...', 'Checking if all guests are really necessary...', 'Checking if somebody will just keep shaking head..', 'Checking if the meeting will last more than 3 minutes...'],
		instructions: 'Not sure if you should schedule a meeting or send an email? We will help you decide...'
	},
	pt: {
		welcomeMsg: "Devemos nos encontrar ou não?",
		recipients: "<Sua lista de Destinatários>",
		subject: "<Um assunto legal>",
		recipientsLabel: 'Para',
		subjectLabel: 'Assunto',
		emailLabel: 'Mensagem',
		meetingReasonLabel: "Motivo da reunião",
		check: "Verificar",
		result: "É só enviar um email!",
		msg: "Espero que tenha entendido!",
		aboutLabel: "Sobre",
		aboutText: `MeetOrNot surge como uma crítica bem-humorada à cultura prevalente de marcar reuniões desnecessárias que poderiam ser facilmente substituídas por um simples e-mail. No ambiente de trabalho acelerado de hoje, reuniões excessivas não apenas interrompem a produtividade, mas também levam à 'fadiga de reunião', contribuindo para o declínio no desempenho da equipe e na motivação individual.
		<br><br>
		Estatísticas revelam que os profissionais gastam aproximadamente 31 horas por mês em reuniões improdutivas, com uma estimativa de 47% considerando reuniões excessivas como o maior desperdício de tempo no escritório. Essa dependência excessiva de reuniões dificulta os processos de tomada de decisão, sufoca a criatividade e muitas vezes leva à negligência de valiosos períodos de trabalho introspectivo conhecidos por fomentar a inovação.
		<br><br>
		Com o MeetOrNot, nosso objetivo é injetar um pouco de humor no local de trabalho, encorajando os profissionais a parar e considerar se outra reunião é realmente necessária ou se o mesmo resultado poderia ser alcançado através de um e-mail bem elaborado. Um brinde à reconquista do seu tempo, aumento da produtividade e melhoria da qualidade da comunicação no local de trabalho!`,
		aboutLink: "Sobre o Autor",
		loadingMessages: ['Verificando se as pessoas estão interessadas...', 'Verificando se é mesmo necessário...', 'Verificando se todos os convidados são mesmo necessários...', 'Analisando se alguém ficará mudo e concordando...', 'Verificando se a reunião tem potencial pra durar mais de 3 minutos...'],
		instructions: 'Não sabe se marca uma reunião ou manda um e-mail? Vamos te ajudar a decidir...'
	}
};

const i18n = new VueI18n( {
	locale: 'pt',
	fallbackLocale: 'pt',
	messages,
} );

Vue.config.productionTip = false;

new Vue( {
	i18n,
	render: h => h( App ),
} ).$mount( '#app' );
